export default "__VITE_ASSET__Bvs_kwJC__"